import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import withStyles from '@material-ui/core/styles/withStyles';
import { InlineDatePicker } from 'material-ui-pickers';
import PropTypes from 'prop-types';
import { CheckCircle, MoreVert } from '@material-ui/icons';
import {
  getMonthName,
  depluralizeResourceName,
  showTwoDecimalsForMoney,
  capitalizeTheFirstLetterOfEachWord,
  changeResourceDisplayName,
} from '../../utils/Functions';
import { sendKmlFile } from '../../api/ImportTool';
import SearchComponent from '../share/SearchComponent';
import MapComponent from '../share/MapComponent';
import {
  getLocations,
  getAdmin,
  getPageSettings,
} from '../../selectors';
import {
  displayResourceStyles,
  viewResourceStyles,
  hourStyle,
  deleteConfirmationDialogStyles,
  generalDialogStyles,
} from '../../css/style';
import DeleteConfirmDialog from '../share/DeleteConfirmDialog';
import LoadingBar from '../share/LoadingBar';
import {
  outOfStockBooleanVersion,
  kmlButtonTitles,
  reportsPageTableRows,
  smallTables,
  bulkActionResourceNames,
  needsRemoveIntegrationPluBeforeDuplicate,
  rewardTypes,
  bulkActions,
  productPaginationCount,
  optionPaginationCount,
  resourceDisplayNameMap,
  YES_ONLY_COUPON_RESTRICTIONS,
  MAX_CHAR_TABLE_FIELD,
} from '../../data/Constants';
import * as CompanyFeatures from '../../services/CompanyFeatures';
import * as SharedOptions from '../../services/SharedOptions';
import {
  titleCase,
  makeSubResourceNameList,
  translation,
  sortByPosition,
} from '../../utils/Functions';
import moment from 'moment';
import { checkIsAuthorized, getLocationIdOfAuthorizationOrAdmin, checkIsLocationAdmin } from '../../utils/AuthorizationChecks';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import flowRight from 'lodash/flowRight';
import get from 'lodash/get';
import DownChevronSelectToggle from '../share/DownChevronSelectToggle';
import GeneralDialog from '../share/GeneralDialog';
import { ViewMoreRow } from './DisplayResources/ViewMoreRow';

const styles = displayResourceStyles();
const viewStyles = viewResourceStyles();
const hourStyles = hourStyle();
const actionConfirmStyles = deleteConfirmationDialogStyles();
const bulkActionStyles = generalDialogStyles();

const customerText = translation('Users.customer');
const pleaseSelectText = translation('pleaseSelectAtLeastOne');

class DisplayResources extends Component {
  constructor(props) {
    super(props);
    const { data, resourceName, actions } = props;
    this.state = {
      anchorEl: null,
      isMenuOpen: data ? new Array(data.length) : [],
      isDeleteConfirmDialogOpen: false,
      dataInDeleteConfirmDialog: '',
      selectedBulkAction: '',
      isBulkActionSelectOpen: false,
      isBulkActionConfirmDialogOpen: false,
      selectedBulkOutOfStockLocations: [],
    };
    if (bulkActionResourceNames.includes(resourceName)) {
      actions.updatePageSettings([resourceName, 'bulkActionIsCheckedMap'], {});
    }
    if (resourceName === 'reports') {
      reportsPageTableRows.forEach((row) => {
        const { reportType } = row;
        this.state[`${reportType}StartDate`] = null;
        this.state[`${reportType}EndDate`] = null;
        this.state[`${reportType}ShowInvalidMessage`] = false;
      });
    }
    this.prepareDisplayValuesMap = this.getPrepareDisplayValuesMap();
  }

  onClickEdit = (data, dataIndex) => {
    const {
      actions, match, history, resourceName, onClickEditResource,
    } = this.props;
    const { resource, resourceId } = match.params;
    actions.clearErrors();

    if (onClickEditResource && typeof onClickEditResource === 'function') {
      onClickEditResource(data.id);
      this.handleMenuClose(dataIndex);
      return;
    }
    if (resourceId) {
      history.push(`/${resource}/${resourceId}/${resourceName}/${data.id}/edit`);
    } else {
      history.push(`/${resourceName}/${data.id}/edit`);
    }
  }

  onClickDelete = async (data, index) => {
    this.setState({
      isDeleteConfirmDialogOpen: true,
      dataInDeleteConfirmDialog: data,
    });
    this.handleMenuClose(index);
  }

  /**
   * Can also duplicate non-shared options
   */
  handleDuplicateSharedOption = async (dataCopy, resourcePath) => {
    const { actions, apiToken, onClickDuplicateResource } = this.props;
    const {
      customizations,
      outOfStockLocations,
      price_add_on,
      sharedId,
      disabled,
      quantity,
      ...restOption
    } = dataCopy;
    const optionRes = await actions.addResource(apiToken, restOption, ...resourcePath);

    const newOption = get(optionRes, 'response');
    if (!newOption) return;
    const outOfStockResponse = await actions.updateResource(apiToken, outOfStockLocations, 'options', newOption.id, 'out-of-stock');
    const nextOOSLocationsToDisplay = cloneDeep(get(outOfStockResponse, 'response'));
    const setModifiersRequestsInfo = customizations.map(idNameObj => ({
      actionName: 'addResource',
      path: ['customizations', idNameObj.id, 'options'],
    }));
    const setModifiersArgs = {
      apiToken,
      option: newOption,
      selectedCustomizations: customizations,
      requestsInfo: setModifiersRequestsInfo,
      stayedSelectedsMap: {},
    };
    const newOptionWithModifiers = await actions.setModifiersOnOptions(setModifiersArgs);

    if (typeof onClickDuplicateResource === 'function') {
      const newOptionForDisplay = Object.assign({}, newOptionWithModifiers, { outOfStockLocations: nextOOSLocationsToDisplay });
      onClickDuplicateResource(newOptionForDisplay);
    }
  }

  /**
   * On click, make a duplicate of the selected resource
   */
  onClickDuplicate = (data, index) => {
    const {
      actions,
      admin,
      match,
      resourceName,
      apiToken,
    } = this.props;
    const {
      resource,
      resourceId,
      subResource,
      subResourceId,
    } = match.params;
    let {
      id, image, hasWarning, ...dataCopy
    } = data;
    if (resource === 'products' || resourceName === 'products') {
      let resourcePath;
      if (resourceId) {
        resourcePath = [resource, resourceId, resourceName, id, 'duplicate'];
      } else {
        resourcePath = [resourceName, id, 'duplicate'];
      }
      actions.duplicateResource(apiToken, resourcePath).then((res) => {
        this.handleMenuClose(index);
      });
    } else if (subResource === 'catering-zones') {
      const resourcePath = [resource, resourceId, subResource, id, 'duplicate'];
      actions.duplicateResource(apiToken, resourcePath).then((res) => {
        this.handleMenuClose(index);
      });
      return;
    } else {
      // todo add api methods for other resources
      let subResourceName;
      let subResource;
      if (resourceName === 'products') {
        subResourceName = 'items';
        subResource = data.items;
        delete dataCopy.outOfStock;
        delete dataCopy.locations;
      } else if (resourceName === 'customizations') {
        subResourceName = 'options';
        subResource = data.options;
      }
      let resourcePath = [resourceName];
      if (resourceId) {
        resourcePath = [resource, resourceId, resourceName];
      }

      if (resourceName === 'coupons') {
        dataCopy.code = `Copy of ${dataCopy.code}`;
      } else {
        dataCopy.name = `Copy of ${dataCopy.name}`;
      }

      if (dataCopy.integrationPLU && needsRemoveIntegrationPluBeforeDuplicate.includes(resourceName)) {
        delete dataCopy.integrationPLU;
      }

      // The API endpoint for product creation automatially strips out any attached items you send
      if (resourceName === 'customizations' && dataCopy.options) {
        delete dataCopy.options;
      }
      if (resourceName === 'options' && dataCopy['out-of-stock']) {
        delete dataCopy['out-of-stock'];
      }

      const isSharedOptionsEnabled = CompanyFeatures.isSharedOptionsEnabled(admin);
      const isTopLevelOptions = resource === 'options';
      const isModifierOptionsTable = resource === 'customizations' && resourceName === 'options';
      if (isSharedOptionsEnabled && (isTopLevelOptions || isModifierOptionsTable)) {
        const path = ['options'];
        this.handleDuplicateSharedOption(dataCopy, path);
        return;
      }

      if (!isSharedOptionsEnabled && isModifierOptionsTable) {
        const cleanedOption = SharedOptions.cleanOptionsKeysForRequests(dataCopy);
        dataCopy = cleanedOption;
      }

      // Add copy of resource
      actions.addResource(apiToken, dataCopy, ...resourcePath).then((res) => {
        if (subResource) {
          subResource.map(async (item) => {
            const { id, ...itemCopy } = item;
            if (itemCopy.integrationPLU && needsRemoveIntegrationPluBeforeDuplicate.includes(subResourceName)) {
              delete itemCopy.integrationPLU;
            }
            if ((subResourceName === 'options' || subResourceName === 'items') && itemCopy['out-of-stock']) {
              delete itemCopy['out-of-stock'];
            }
            const resourceId = res.response.id;
            // Add subresource
            await actions.addResource(apiToken, itemCopy, resourceName, resourceId, subResourceName)
              .then((res) => {
                if (res.error) return;
                if (subResourceName !== 'items') return;
                const newItem = res.response;
                const customizations = item.customizations;
                const options = item.includedOptions;
                const mainPath = [resourceName, resourceId, subResourceName, newItem.id];
                actions.updateResource(apiToken, customizations, ...mainPath, 'customizations');
                actions.updateResource(apiToken, options, ...mainPath, 'includedOptions');
              });
          });
        }
        this.handleMenuClose(index);
      });
    }
  };

  onClickRowSelection = (rowId, column) => {
    // user needs to click first column to view resource
    const {
      resourceName,
      match,
      history,
      admin,
      onClickEditResource,
    } = this.props;
    const { resource, resourceId, subResource } = match.params;
    if (!checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'edit')) return;
    if (typeof onClickEditResource === 'function') {
      // if the column contains links to modifiers, then don't link to the edit options page
      if (resourceName === 'options' && column === 2) return;
      onClickEditResource(rowId);
      return;
    }
    if (resourceName === 'reports') return;
    if (column === 0 || column === undefined) {
      if (resource === 'orders' && !subResource) {
        history.push(`/${resource}/${rowId}/items`);
        return;
      }
      if (resourceId) {
        history.push(`/${resource}/${resourceId}/${subResource}/${rowId}/edit`);
      } else {
        history.push(`/${resourceName}/${rowId}/edit`);
      }
    }
  }

  onClickCustomButton = (rowId, btnType) => {
    const { resourceName, history } = this.props;
    history.push(`/${resourceName}/${rowId}/${btnType}/`);
  };

  getDisplayAndExcessNames = (fieldData, displayNames = [], excessNames = [], authorized = false) => {
    let charLen = 0;
    const displayValues = fieldData.map((displayValue) => {
      if (!displayValue.name) return '';
      const displayValueName = displayValue.name;
      const val = !authorized ? displayValueName : displayValue;
      if (charLen + displayValueName.length < MAX_CHAR_TABLE_FIELD) {
        charLen += displayValueName.length;
        displayNames.push(val);
      } else {
        excessNames.push(displayValueName);
      }
      return val;
    });
    return displayValues;
  }

  getModifierDisplayValue = (fieldData, displayNames = [], excessNames = []) => {
    return this.getDisplayAndExcessNames(fieldData, displayNames, excessNames, false);
  }

  getOutOfStockDisplayValue = (fieldData, displayNames = [], excessNames = []) => {
    const { resource, subResource } = this.props.match.params;
    const { locations, isFromCreateEditModifier } = this.props;
    if (fieldData === false) return 'NO';
    if (!Array.isArray(fieldData) || !Array.isArray(locations)) return '';
    if (fieldData.length === 0) return 'NO';
    if (locations.length === fieldData.length) return 'All Locations';

    let names = [];
    if (resource === 'menu') {
      names = fieldData.map((locationId, ind, arr) => {
        const locationInfo = locations.find(location => `${location.id}` === `${locationId}`);
        if (!locationInfo || !locationInfo.name) return '';
        return locationInfo.name;
      });
    }
    if ((resource === 'options') || (resource === 'customizations' && subResource === 'options') || isFromCreateEditModifier) {
      return this.getDisplayAndExcessNames(fieldData, displayNames, excessNames, false);
    }
    const filteredEmptyValuesOut = names.filter(name => !!(name));
    return filteredEmptyValuesOut.join('\n\r');
  }

  getDisplayValueInStringFormat = (displayNames, excessNames, displayValues, excessCount) => {
    if (excessCount > 0) {
      excessNames = excessNames.join(', ');
      return displayNames.join(', ');
    }
    return (!Array.isArray(displayValues)) ? displayValues : displayValues.join(', ');
  };

  showDropdownListValues = (fieldData, fieldKey) => {
    let displayNames = [];
    let excessNames = [];
    let displayValues = fieldKey === 'customizations' ? this.getModifierDisplayValue(fieldData, displayNames, excessNames) : this.getOutOfStockDisplayValue(fieldData, displayNames, excessNames);
    const excessCount = excessNames.length;
    displayValues = this.getDisplayValueInStringFormat(displayNames, excessNames, displayValues, excessCount);
    return {
      displayValues, excessCount, excessNames,
    };
  }

  renderDropdownListWithExcessCount = (displayValues, excessNames, excessCount) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography component='div'>
        {displayValues}
        {' ... '}
        <Tooltip title={`${excessNames}`} enterTouchDelay={0}>
          <span style={styles.excessCountCircle}>
            <Typography style={styles.excessCountText}>{`+${excessCount}`}</Typography>
          </span>
        </Tooltip>
      </Typography>
    </div>
    );
  }

  getFieldDataFromType = (fieldData, field) => {
    const { resource, subResource } = this.props.match.params;
    const stringKeys = [
      'component', 'customizationView',
      'posIntegration', 'paymentIntegration',
      'reportFrequency', 'actionType',
      'rewardType',
    ];
    if (fieldData === undefined || fieldData === null || field.key === 'orderStatus') return fieldData;
    if (field.key === 'percentage') return fieldData;
    if (['totalPrice', 'totalRedeemedAmount'].includes(field.key)) return showTwoDecimalsForMoney(fieldData);

    switch (field.type) {
      case 'viewListWithQuantity':
        if (resource === 'orders' && subResource === 'items' && field.key === 'options' && Array.isArray(fieldData)) {
          const names = fieldData.map((optionOrSubItem) => {
            // subItem
            if (optionOrSubItem.hasOwnProperty('portion')) {
              const portionName = get(optionOrSubItem, 'portion.name', translation('OrderItems.pizzaHalvesNull'));
              const itemName = get(optionOrSubItem, 'productItem.name', translation('OrderItems.productItemNull'));
              return `${portionName} - ${itemName}`;
            }
            // option
            return `${titleCase(optionOrSubItem.name)} x ${optionOrSubItem.quantity}`;
          });
          return names.join('\n\r');
        }
        if (!Array.isArray(fieldData)) return '';
      case 'nameOnly':
        return titleCase(`${fieldData.attribute_value} ${fieldData.name}`);
      case 'boolean':
        if (['outOfStock', 'out-of-stock'].includes(field.key)) {
          const { locations } = this.props;
          if (Array.isArray(fieldData) && Array.isArray(locations)) {
            if (locations.length === 0) return 'No business locations yet';
            if (locations.length === 1) {
              return fieldData.length === 1 ? 'YES' : 'NO';
            }
          }
        }
        if (['exclusive', 'autoApply'].includes(field.key)) {
          if (fieldData) {
            return (
              <div style={styles.checkCircleSpacing}>
                <CheckCircle color="primary" />
              </div>
            );
          }
          return ' ';
        }
        return fieldData ? 'YES' : 'NO';
      case 'decimal':
        return parseFloat(fieldData).toFixed(2);
      case 'dropdown':
        if (field.key === 'maxQuantity') {
          return fieldData;
        }
        if (['outOfStock', 'out-of-stock', 'outOfStockLocations'].includes(field.key) || field.key === 'customizations') {
          const { displayValues, excessCount, excessNames } = this.showDropdownListValues(fieldData, field.key);
          return excessNames.length === 0 ? displayValues : this.renderDropdownListWithExcessCount(displayValues, excessNames, excessCount);
        }
        if (field.key === 'type' && this.props.match.params.subResource === 'restrictions') {
          return titleCase(fieldData);
        }
        if (stringKeys.includes(field.key)) {
          // This runs if the dropdown value is a STRING - converts "STRING" to "String"
          return fieldData.charAt(0).concat(fieldData.slice(1).toLowerCase());
        }
        return fieldData.name; // Runs if the dropdown value is an OBJECT
      default:
        return fieldData;
    }
  }

  /**
   * If fieldData is null, undefined, NaN, empty string (""), 0,
   * or false => show as N/A.
   */
  getEmptyValuesForField = (data, fieldKey, rowData) => {
    // An empty string can be an intermediate result when the Menu component is requesting for all locations, after coming from the Locations page, which puts a subset of all locations in the Redux store.
    // The Product Menu's display out of stock logic depends on the full list of all business locations to compare <location_id>s with.
    if (fieldKey === 'outOfStock' && data === '') return '';
    if (fieldKey === 'points' && data === 0) return '00';

    if (!data) {
      if (fieldKey === 'maxQuantity' && data === 0) return '0';
      return 'N/A';
    }

    return data;
  }

  /**
   * @description
   * render view more button as a row in the table for those resources that have pagination
   */
  renderViewMoreTableBodyRow = (rowData) => {
    const {
      buttonArray, fieldNames, viewMoreLoading, onClickViewMore, data, totalResource, isFiltersSameAsLastUsedFilters, resourceName, submitFilters,
    } = this.props;
    return (
      !(data.length - 1 >= totalResource)
      && (
        <TableRow key={rowData.id} style={{ height: '40px' }}>
          <TableCell
            key={rowData.id}
            colSpan={buttonArray ? fieldNames.length + 1 : fieldNames.length}
            style={styles.viewMoreTableCell}
          >
            {
              viewMoreLoading > 0
                ? 'Loading...'
                : (
                  <ViewMoreRow
                    onClickViewMore={onClickViewMore}
                    rowData={rowData}
                    isFiltersSameAsLastUsedFilters={isFiltersSameAsLastUsedFilters}
                    resourceName={resourceName}
                    submitFilters={submitFilters}
                  />
                )
            }
          </TableCell>
        </TableRow>
      )
    );
  }

  getRowHeightAndColor = (rowData, dataIndex, bandedTable, isTablet) => {
    if (Object.keys(rowData).includes('coordinates')) {
      return styles.lightTableRowWithMapComponentHeight;
    }
    if (bandedTable && dataIndex % 2 === 0) return styles.bandedTableLightTableRow;
    if (bandedTable) return styles.bandedTableDarkTableRow;
    if (!bandedTable && !isTablet) return styles.v1TableRow;
    if (isTablet) return styles.tabletTableRowHeight;
  }

  shouldWrapIfNewlineCharsPresent = (rowData, field) => {
    const { resource, subResource } = this.props.match.params;
    const isProductListRestriction = rowData.type && ['CATEGORY', 'EXCLUDE_CATEGORY', 'PRODUCT', 'EXCLUDE_PRODUCT', 'PRODUCT_ITEM', 'EXCLUDE_PRODUCT_ITEM'].includes(rowData.type);
    const { shouldWrapNewLines } = field;

    return isProductListRestriction || shouldWrapNewLines;
  }

  getCellHeightAndStyle = (rowData, isSmallTable, field, index, isTablet) => {
    const { bandedTable, match } = this.props;
    const { resource, subResource } = match.params;
    const paddingLeft = bandedTable && index === 0 ? '16' : '10';
    const paddingStyles = {
      tabletStyle: '30px 10px 30px 10px',
      smallTableStyle: '0 15px 0 5px',
      defaultPadding: `20px 50px 20px ${paddingLeft}px`,
    };
    const getPaddingTypeStyle = (isTablet, isSmallTable) => {
      if (isTablet) {
        return paddingStyles.tabletStyle;
      } else if (isSmallTable) {
        return paddingStyles.smallTableStyle;
      } else {
        return paddingStyles.defaultPadding;
      }
    };
    const normalCell = {
      fontFamily: 'Lato',
      fontSize: '14px',
      color: '#000',
      borderBottom: bandedTable ? 'none' : '2px solid #f2f2f2',
      padding: getPaddingTypeStyle(isTablet, isSmallTable),
    };
    if (field.key === 'downloadCsvButton') {
      normalCell.padding = '20px 0px 20px 10px';
    }
    if (resource === 'coupons') {
      normalCell.padding = '20px 10px';
      if (field.key === 'actionValue') {
        normalCell.textAlign = 'center';
      }
    }
    if (resource === 'orders') {
      normalCell.fontSize = '13px';
      if (field.key === 'orderStatus') {
        normalCell.paddingRight = '0px';
        normalCell.fontSize = '12px';
      }
      if (field.key === 'telephone' || field.key === 'desiredTime') {
        normalCell.whiteSpace = 'nowrap';
      }
    }
    if (resource === 'users') {
      normalCell.textAlign = 'center';
      normalCell.fontSize = '12px';
      normalCell.padding = '20px 3px';
      if (field.key === 'lastOrder' || field.key === 'telephone') {
        normalCell.whiteSpace = 'nowrap';
      }
    }
    if (resource === 'reports' && this.state[`${rowData.reportType}ShowInvalidMessage`]) {
      normalCell.verticalAlign = 'top';
      if (field.key === 'type') {
        normalCell.padding = `34px 50px 20px ${paddingLeft}px`;
      }
      if (field.key === 'dateRange') {
        normalCell.height = '60px';
        normalCell.padding = '24px 50px 20px 10px';
      }
    }
    if ((resource === 'options' || subResource === 'options')) {
      normalCell.paddingTop = '30px';
      normalCell.paddingBottom = '30px';
      normalCell.paddingLeft = '20px';
    }
    if (Object.keys(rowData).includes('coordinates')) {
      normalCell.height = '400px';
      return normalCell;
    } else if (this.shouldWrapIfNewlineCharsPresent(rowData, field)) {
      // 'pre' for 'pre-formatted' makes newlines show up for text in <td> elements
      normalCell.whiteSpace = 'pre-wrap';
      return normalCell;
    } else {
      return normalCell;
    }
  }

  checkIsAdminUser = () => {
    const { admin } = this.props;
    if (!admin || !admin.email) return;
    const craverStaffAddress = /@admin\.com$/;
    return craverStaffAddress.test(admin.email);
  }

  renderDeleteButton = (rowData, dataIndex) => {
    const { resourceName, data, admin } = this.props;

    const isAuthorizedForLocations = checkIsAuthorized(admin, 'locations', null, 'add');
    if (resourceName === 'locations' && !isAuthorizedForLocations) return;
    if (resourceName === 'items' && Array.isArray(data) && data.length < 2) return;
    return <MenuItem onClick={() => this.onClickDelete(rowData, dataIndex)}>Delete</MenuItem>;
  }

  hofToggleCheckbox = rowData => (event, checked) => {
    const { actions, pageSettings, resourceName } = this.props;
    const bulkActionIsCheckedMap = pageSettings && get(pageSettings, `${resourceName}.bulkActionIsCheckedMap`, {});
    const newIsCheckedValue = event.target.checked;
    const newBulkActionIsCheckedMap = Object.assign({}, bulkActionIsCheckedMap);
    newBulkActionIsCheckedMap[rowData.id] = newIsCheckedValue;
    actions.updatePageSettings([resourceName, 'bulkActionIsCheckedMap'], newBulkActionIsCheckedMap);
  }

  renderBulkActionCheckbox = (rowData, classes) => {
    const { pageSettings, resourceName } = this.props;
    const bulkActionIsCheckedMap = pageSettings && get(pageSettings, `${resourceName}.bulkActionIsCheckedMap`, {});
    const isChecked = get(bulkActionIsCheckedMap, `${rowData.id}`, false);

    return (
      <Checkbox
        checked={isChecked}
        color="primary"
        onChange={this.hofToggleCheckbox(rowData)}
        icon={<Icon style={styles.uncheckedCheckboxIcon}>check_box_outline_blank</Icon>}
        checkedIcon={<Icon style={styles.checkedCheckboxIcon}>check_box</Icon>}
        classes={{ root: classes.bulkActionCheckbox }}
      />
    );
  }

  getPrepareDisplayValuesMap = () => {
    const map = new Map();
    map.set((resource, resourceName, subResource, rowData, field) => (resource === 'orders' && subResource === 'items' && field.key === 'options'), this.renderPizzaPortions);
    map.set((resource, resourceName, subResource, rowData, field) => (subResource === 'restrictions' && field.key === 'value'), this.getRestrictionsDisplayValue);
    map.set((resource, resourceName, subResource, rowData, field) => (['outOfStock', 'out-of-stock'].includes(field.key) && Array.isArray(this.props.locations)), this.showOutOfStockDisplayValue);
    map.set((resource, resourceName, subResource, rowData, field) => (resourceName === 'options' && field.key === 'customizations'), this.showCustomizationDisplayValue);
    map.set((resource, resourceName, subResource, rowData, field) => ((resource === 'categories' || resource === 'menu') && field.key === 'timeLimits'), this.newLineSeparatedTimeLimits);
    map.set((resource, resourceName, subResource, rowData, field) => (resourceName === 'customizations' && !subResource && field.key === 'options'), this.getCustomizationOptionsDisplayValue);
    map.set((resource, resourceName, subResource, rowData, field) => (resourceName === 'tiers' && field.key === 'productItems' && rowData.rewardType === rewardTypes.DOLLAR), this.makeFieldDataNull);
    map.set((resource, resourceName, subResource, rowData, field) => (field.key === 'birthMonth'), this.getMonthNameForBirthMonth);
    map.set((resource, resourceName, subResource, rowData, field) => (field.key === 'isSingleSelectDefault'), this.singleSelectDefaultOption);
    map.set((resource, resourceName, subResource, rowData, field) => (field.key === 'value' && rowData.type && YES_ONLY_COUPON_RESTRICTIONS.includes(rowData.type)), this.getYesOnlyCouponDisplayValue);
    map.set((resource, resourceName, subResource, rowData, field) => (field.key === 'actionValue' && resource === 'coupons'), this.getCouponActionValue);
    return map;
  }

  getCouponActionValue = ({ fieldData, rowData }) => {
    const { actionType } = rowData;
    if (actionType === rewardTypes.DOLLAR) return `$${fieldData}`;
    if (actionType === rewardTypes.PERCENT) return `${fieldData}%`;
    return fieldData;
  }

  shouldShowBulkCheckbox = () => {
    const { hideBulkActions, resourceName } = this.props;
    const { resource } = this.props.match.params;
    if (hideBulkActions) return false;
    return bulkActionResourceNames.includes(resourceName) && !((resourceName === 'categories' && resource === 'menu'));
  }

  /**
   * @param rowData data object of each row
   * @param dataIndex index of each row
   * @description
   * render each row in a table, used by all resources
   */
  renderTableBodyRow = (rowData, dataIndex) => {
    const { anchorEl, isMenuOpen } = this.state;
    const {
      fieldNames,
      buttonArray,
      resourceName,
      viewOnly,
      data,
      isSmallTable,
      usersCheckbox,
      onChangeUsersCheckbox,
      pageSettings,
      onCategoryCheckBoxChange,
      match,
      locations,
      admin,
      bandedTable,
      classes,
      isTablet,
    } = this.props;
    const { resource, subResource } = match.params;
    const open = Boolean(isMenuOpen[dataIndex]);
    const rowId = rowData.id;
    const ifTabletCellPadding = isTablet ? '20px 10px 20px 10px' : '20px 50px 20px 10px';
    const tableCellStyle = {
      ...styles.mainTableCell,
      padding: isSmallTable ? '0 15px 0 5px' : ifTabletCellPadding,
    };
    const tableButtonStyle = {
      ...tableCellStyle,
      position: 'relative',
      padding: '0',
    };
    const tableButtonStyleOptions = {
      ...tableButtonStyle,
      borderBottomRightRadius: '5px',
      borderTopRightRadius: '5px',
    };
    if (rowData.blurDisplay) {
      tableCellStyle.color = '#9b9b9b';
    }

    const correctAttemptedDeleteName = checkIsLocationAdmin(admin) ? 'deleteAsLocationAdmin' : 'delete';
    return (
      <TableRow hover={resourceName === 'options'} key={rowData.id} style={this.getRowHeightAndColor(rowData, dataIndex, bandedTable, isTablet)}>
        {
          ((resourceName === 'categories' && resource === 'menu') || resourceName === 'users')
          && (
            <TableCell key={data.id} style={styles.buttonTableCell}>
              <Checkbox
                checked={
                  resourceName === 'users'
                    ? Boolean(usersCheckbox && usersCheckbox[dataIndex])
                    : Boolean(pageSettings && pageSettings.menu && pageSettings.menu.categoryIdsIsCheckedMap && pageSettings.menu.categoryIdsIsCheckedMap[rowId])
                }
                style={styles.checkBox}
                onChange={(event) => {
                  if (resourceName === 'users') {
                    onChangeUsersCheckbox(event, dataIndex);
                  } else {
                    onCategoryCheckBoxChange(rowId);
                  }
                }}
              />
            </TableCell>
          )
        }
        {
          this.shouldShowBulkCheckbox()
          && (
            <TableCell
              key={`BulkActionButton${rowData.id}`}
              style={resourceName !== 'options' ? styles.buttonTableCell : styles.optionsBulkActionTableCell}
            >
              {this.renderBulkActionCheckbox(rowData, classes)}
            </TableCell>
          )
        }
        {
          fieldNames.map((field, index, arr) => {
            let fieldData;
            if ((resource === 'categories' || resource === 'menu') && field.key === 'timeLimits' && isSmallTable) return;
            if (resourceName === 'customizations' && !subResource && field.key === 'options' && isSmallTable) return;
            if (resourceName === 'categories' && field.key === 'isDisabled' && isSmallTable) return;
            if (isSmallTable && resourceName === 'customizations' && ['minOptions', 'maxOptions', 'isMandatory'].includes(field.key)) return;
            if (!(resource === 'orders' && subResource === 'items' && field.key === 'options')) {
              fieldData = this.getFieldDataFromType(rowData[field.key], field);
            }
            let allPossibleArgsNeeded = {
              rowData, fieldData, field, admin, resource, data, subResource,
            };
            if (field.key === 'totalPrice') {
              let totalAmountAfterDiscount = this.getFieldDataFromType(rowData[field.key], field) - rowData.totalRedeemedAmount;
              fieldData = showTwoDecimalsForMoney(totalAmountAfterDiscount);
            }

            this.prepareDisplayValuesMap.forEach((valFunc, keyFunc) => {
              if (!!keyFunc(resource, resourceName, subResource, rowData, field)) fieldData = valFunc(allPossibleArgsNeeded);
              allPossibleArgsNeeded = {
                rowData, fieldData, field, admin, resource, data, subResource,
              };
            });
            fieldData = this.getEmptyValuesForField(fieldData, field.key, rowData);

            return (
              !field.hideInDisplay
              && (
                <TableCell
                  style={this.getCellHeightAndStyle(rowData, isSmallTable, field, index, isTablet)}
                  onClick={() => this.onClickRowSelection(rowData.id, index)}
                  key={field.key + rowData.id}
                >
                  {this.renderTableCellContents(field, fieldData, dataIndex, rowData)}
                  {
                    (index === 0 && rowData.hasWarning)
                    && (
                      <Tooltip title='Please add one or more Product Items to make this Product visible in the app.'>
                        <Icon color="error" style={{ verticalAlign: 'middle' }}>
                          warning
                        </Icon>
                      </Tooltip>
                    )
                  }
                </TableCell>
              )
            );
          })
        }
        {
          (buttonArray || !viewOnly)
          && (
            <TableCell
              key={`iconButton${rowData.id}`}
              style={resourceName !== 'options' ? tableButtonStyle : tableButtonStyleOptions}
            >
              <div style={styles.checkboxAndThreeDotsMenuContainer}>
                <IconButton
                  style={styles.threeDotsIconButton}
                  onClick={event => this.handleMenuOpen(event, dataIndex)}
                >
                  <MoreVert />
                </IconButton>
                <Menu
                  id={rowData.id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={() => this.handleMenuClose(dataIndex)}
                >
                  {
                    checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'edit')
                    && (
                      <MenuItem
                        style={styles.editOption}
                        onClick={() => this.onClickEdit(rowData, dataIndex)}
                      >
                        Edit
                      </MenuItem>
                    )
                  }
                  {
                    checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'add')
                    && resourceName !== 'users'  
                    && resourceName !== 'orders'
                    && <MenuItem onClick={() => this.onClickDuplicate(rowData, dataIndex)}>Duplicate</MenuItem>
                  }
                  {
                    resourceName !== 'users'
                    && (checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), correctAttemptedDeleteName)
                      && this.renderDeleteButton(rowData, dataIndex))
                  }
                  {resourceName === 'orders' && <MenuItem onClick={() => this.onClickRowSelection(rowId)}>View</MenuItem>}
                  {
                    resourceName !== 'products' && buttonArray && buttonArray.map((button) => {
                      let kmlInput;
                      let buttonComponent = (
                        <MenuItem onClick={() => this.onClickCustomButton(rowId, button.btnTitle)}>
                          {this.formatResourceButtonName(button)}
                        </MenuItem>
                      );
                      if (!kmlButtonTitles.includes(button.btnTitle)
                        && checkIsAuthorized(admin, resource, button.btnTitle, 'view')) return [buttonComponent, kmlInput];

                      const isDeliveryZoneKml = button.btnTitle === 'kml';
                      kmlInput = (
                        <input
                          id={isDeliveryZoneKml ? 'kmlInput' : 'cateringZoneKmlInput'}
                          type="file"
                          accept=".kml"
                          ref={ref => this[isDeliveryZoneKml ? 'kmlInput' : 'cateringZoneKmlInput'] = ref}
                          style={{ display: 'none' }}
                          onChange={this.handleKmlFile.bind(this, rowId, isDeliveryZoneKml ? 'kml' : 'catering-zones')}
                        />
                      );
                      buttonComponent = (
                        <MenuItem onClick={() => this[isDeliveryZoneKml ? 'kmlInput' : 'cateringZoneKmlInput'].click()}>
                          {`Upload .kml for ${isDeliveryZoneKml ? 'Delivery' : 'Catering'} Zone`}
                        </MenuItem>
                      );
                      const zonesSubResource = isDeliveryZoneKml ? 'zones' : 'catering-zones';
                      const checkDeliveryZoneAuthorized = attemptedAction => checkIsAuthorized(admin, resource, zonesSubResource, attemptedAction);
                      return [
                        checkDeliveryZoneAuthorized('view') && buttonComponent,
                        checkDeliveryZoneAuthorized('add') && kmlInput,
                      ];
                    })
                  }
                </Menu>
              </div>
            </TableCell>
          )
        }
      </TableRow>
    );
  }

  /**
   * Returns a small table's props.resourceName over the match.params.subResource.
   *
   * Helps AuthorizationChecks.checkIsAuthorized distinguish between e.g. the small Customizations table in the Menu page,
   * and the Customizations-only page.
   *
   * Since it returns match.params.subResource, if you are on e.g. the /customizations page, and want to see if you are
   * authorized to see the 'Options' button in the three dots menu, then this function will not help, since 'options' is not yet
   * in match.params. In that case, get 'options' another way.
   */
  getRightSubResourceOrSmallTableParam = () => {
    const { resourceName, match } = this.props;
    const { resource, subResource } = match.params;
    return resource === 'menu' && smallTables.includes(resourceName) ? resourceName : subResource;
  }

  newLineSeparatedTimeLimits = ({ rowData, field }) => this.getNewlineSeparatedTimeLimits(rowData[field.key]);

  getNewlineSeparatedTimeLimits = (timeLimits) => {
    if (!Array.isArray(timeLimits)) return '';
    const timeLimitsToStrings = timeLimits.map((timeAndDayInfo) => {
      const { start, end, daysOfWeek } = timeAndDayInfo;
      let joinedDaysOfWeek = '';
      if ((!daysOfWeek || Array.isArray(daysOfWeek) && daysOfWeek.length === 0) && start && end) {
        joinedDaysOfWeek = 'Every day';
      } else if (Array.isArray(daysOfWeek) && daysOfWeek.length > 0) {
        joinedDaysOfWeek = daysOfWeek.join(', ');
      }
      const twelveHourStart = start ? moment(start, ['H:m', 'H:mm', 'HH:m', 'HH:mm'], true).format('h:mm A') : 'Invalid time';
      let twelveHourEnd;
      if (end) {
        twelveHourEnd = moment(end, ['H:m', 'H:mm', 'HH:m', 'HH:mm'], true).format('h:mm A');
        // One record in production has a start time but no end time
      } else if (!end && start) {
        twelveHourEnd = 'Add an end time to activate this feature';
      } else if (!end && !start) {
        twelveHourEnd = 'Invalid time';
      }
      return `${twelveHourStart} - ${twelveHourEnd} • ${joinedDaysOfWeek}`;
    });
    return timeLimitsToStrings.join(timeLimits.length > 1 ? '\n\r' : '');
  }

  getQueryParamsForReport = (reportType, formattedStartDate, formattedEndDate, timezone, locationID) => {
    const reportTypeQuery = `companies/${reportType}-report?start-date=${formattedStartDate}&end-date=${formattedEndDate}`;
    switch (reportType) {
      case 'userData':
        return `companies/export/excel/users?from=${formattedStartDate}&to=${formattedEndDate}&timezone=${timezone}`;
      case 'sales':
        return (!locationID || locationID === 0) ? reportTypeQuery : `companies/sales-report?start-date=${formattedStartDate}&end-date=${formattedEndDate}&location=${locationID}`;
      default:
        return reportTypeQuery;
    }
  }

  renderTableCellContents = (field, fieldData, dataIndex, rowData) => {
    // default case is final line of method -> return fieldData;
    const {
      match,
      locations,
      resourceName,
      actions,
      apiToken,
      admin,
      selectedLocation,
    } = this.props;

    if (field.key === 'coordinates') {
      return (
        <div style={{ height: '350px', width: '500px' }}>
          <MapComponent locations={locations} match={match} rowNumber={dataIndex} />
        </div>
      );
    }
    if (resourceName === 'reports' && field.type && field.type === 'dateRange') {
      const { reportType } = rowData;
      const startDate = this.state[`${reportType}StartDate`];
      const endDate = this.state[`${reportType}EndDate`];
      const showIsInvalidMessage = this.state[`${reportType}ShowInvalidMessage`];

      // Start date max (latest) date should be the end date.
      // If no endDate defined, then start date max date is today.
      // End date min date (earliest) should be the start date. If no start date, then use a date that should include all dates the business had transactions.
      return (
        <Fragment>
          <div style={styles.dateRangeInputsContainer}>
            <InlineDatePicker
              openTo="month"
              views={['year', 'month', 'day']}
              value={startDate}
              onChange={momentObj => this.handleDateChange(momentObj, rowData.reportType, 'Start')}
              maxDate={endDate || moment()}
              format="YYYY/MM/DD"
            />
            <div style={hourStyles.dashInbetween}> - </div>
            <InlineDatePicker
              openTo="month"
              views={['year', 'month', 'day']}
              value={endDate}
              onChange={momentObj => this.handleDateChange(momentObj, rowData.reportType, 'End')}
              maxDate={moment()}
              minDate={startDate || moment(new Date(0))}
              format="YYYY/MM/DD"
            />
          </div>
          {showIsInvalidMessage && (
            <div style={styles.invalidReportDateRangeMessage}>
              <Typography>Both dates are needed</Typography>
            </div>
          )}
        </Fragment>
      );
    }

    if (resourceName === 'reports' && field.key === 'downloadCsvButton') {
      const { reportType } = rowData;
      const startDate = this.state[`${reportType}StartDate`];
      const endDate = this.state[`${reportType}EndDate`];
      const apiExpectedDateFormat = reportType === 'userData' ? 'YYYYMMDD' : 'YYYY-MM-DD';
      const formattedStartDate = startDate ? startDate.format(apiExpectedDateFormat) : null;
      const formattedEndDate = endDate ? endDate.format(apiExpectedDateFormat) : null;
      const timezone = locations ? encodeURIComponent(locations[0].timezone) : '';
      const locationID = locations && selectedLocation[0] ? selectedLocation[0].value : 0;

      const queryParams = this.getQueryParamsForReport(reportType, formattedStartDate, formattedEndDate, timezone, locationID);

      const hofDownloadCsvFile = () => {
        if (!startDate || !endDate) {
          this.setState({ [`${reportType}ShowInvalidMessage`]: true });
          return;
        }
        this.setState({ [`${reportType}ShowInvalidMessage`]: false });
        actions.downloadResource(apiToken, queryParams);
      };
      return (
        <div style={styles.downloadCsvButtonFlexEndContainer}>
          <Button
            onClick={hofDownloadCsvFile}
            style={styles.downloadCsvButton}
          >
            DOWNLOAD CSV
            <Icon style={styles.downloadCsvButtonIcon}>cloud_download</Icon>
          </Button>
        </div>
      );
    }
    return fieldData;
  }

  handleDateChange = (momentObj, reportType, startOrEnd) => {
    const intendedUpdate = `${reportType}${startOrEnd}Date`;
    const startDate = this.state[`${reportType}StartDate`];
    const endDate = this.state[`${reportType}EndDate`];
    const oneOrMoreDatesMissing = startOrEnd === 'Start' ? !endDate || !momentObj : !startDate || !momentObj;

    this.setState({
      [intendedUpdate]: momentObj,
      [`${reportType}ShowInvalidMessage`]: oneOrMoreDatesMissing,
    });
  }

  /**
   * render table head
   */
  renderTableHeader = () => {
    const {
      fieldNames,
      buttonArray,
      resourceName,
      viewOnly,
      onOpenNotificationDialog,
      onChangeAllUsersCheckbox,
      allUsersCheckbox,
      usersCheckbox,
      match,
      bandedTable,
      pageSettings,
      isTablet,
    } = this.props;
    const { resource } = match.params;
    return (
      !(resourceName === 'taxes' || (resourceName === 'customizations' && resource === 'menu') || (resourceName === 'categories' && resource === 'menu'))
      && (
        <TableRow key="header" style={{ height: '40px' }}>
          {
            resourceName === 'users'
            && (
              <TableCell
                style={{
                  ...styles.tableHeadCell,
                  padding: '0',
                }}
              >
                <Tooltip title={`${allUsersCheckbox ? 'Unselect' : 'Select'} All Users`}>
                  <Checkbox
                    checked={allUsersCheckbox}
                    style={styles.checkBox}
                    onChange={event => onChangeAllUsersCheckbox(event)}
                  />
                </Tooltip>
              </TableCell>
            )
          }
          {
            this.renderBulkActionTableHeadCell(resourceName)
          }
          {fieldNames.map((field, index) => !field.hideInDisplay
            && (
              <TableCell variant="head" style={this.getHeaderCellStyle(field, resourceName, index, bandedTable, isTablet)} key={field.key}>
                {this.renderHeaderCellContents(field, pageSettings, resourceName)}
              </TableCell>
            ))}
          {
            this.renderLastColumnTableHeadCell(resourceName)
          }
          {
            resourceName === 'users'
            && (
              <Tooltip title={this.props.usersCheckbox.every(user => !user) ? `${pleaseSelectText}${customerText}` : ''}>
                <Button
                  style={{ ...styles.addNewResButton, ...styles.sendPushNotificationButton }}
                  onClick={() => onOpenNotificationDialog()}
                >
                  <Icon style={{ paddingRight: '10px' }}>send</Icon>
                  {'Send Push Notification'}
                </Button>
              </Tooltip>
            )
          }
        </TableRow>
      )
    );
  }

  renderLastColumnTableHeadCell = (resourceName) => {
    if (!resourceName) return;
    const { bandedTable, buttonArray, viewOnly } = this.props;
    const isDisplay = (buttonArray || !viewOnly);
    if (resourceName === 'orders' && isDisplay) return <TableCell style={styles.lastColumnOrderCell} key="iconButton" />;
    return isDisplay && <TableCell style={resourceName !== 'options' ? styles.tableHeadCell : { ...styles.tableHeadWithBackgroundColor, width: '50px' }} key="iconButton" />;
  }

  renderBulkActionTableHeadCell = (resourceName) => {
    const { hideBulkActions } = this.props;
    if (hideBulkActions) return null;
    if (bulkActionResourceNames.includes(resourceName)) {
      return (
        <TableCell variant="head" style={resourceName !== 'options' ? styles.bulkActionCheckboxTableHeadCell : styles.bulkActionCheckboxOptionTableHeadCell} key={`${resourceName}BulkActionCheckbox`}>
          {this.renderBulkActionSelectAllCheckbox(resourceName)}
        </TableCell>
      );
    }
  };

  renderHeaderCellContents = (field, pageSettings, resourceName) => field.key !== 'downloadCsvButton' && field.title.toUpperCase()

  toggleSelectAllCheckbox = (event, checked) => {
    const {
      pageSettings,
      data,
      resourceName,
      actions,
    } = this.props;
    const bulkActionIsCheckedMap = get(pageSettings, `${resourceName}.bulkActionIsCheckedMap`, {});
    const newIsCheckedValue = event.target.checked;
    const newBulkActionIsCheckedMap = Object.assign({}, bulkActionIsCheckedMap);
    newBulkActionIsCheckedMap.all = newIsCheckedValue;
    if (bulkActionResourceNames.includes(resourceName) && Array.isArray(data)) {
      data.forEach(resource => newBulkActionIsCheckedMap[resource.id] = newIsCheckedValue);
    }
    actions.updatePageSettings([resourceName, 'bulkActionIsCheckedMap'], newBulkActionIsCheckedMap);
  }

  renderBulkActionSelectAllCheckbox = (resourceName) => {
    const { pageSettings } = this.props;
    const isChecked = get(pageSettings, [resourceName, 'bulkActionIsCheckedMap', 'all'], false);

    return (
      <div style={resourceName !== 'options' ? styles.checkboxAndThreeDotsMenuContainer : null}>
        <Checkbox
          checked={isChecked}
          color="primary"
          onChange={this.toggleSelectAllCheckbox}
          icon={<Icon style={styles.uncheckedCheckboxIcon}>check_box_outline_blank</Icon>}
          checkedIcon={<Icon style={styles.checkedCheckboxIcon}>check_box</Icon>}
          style={styles.bulkActionCheckbox}
        />
      </div>
    );
  }

  getHeaderCellStyle = (field, resourceName, index, bandedTable, isTablet) => {
    const { resource } = this.props.match.params;
    if (bandedTable) return index === 0 ? styles.bandedTableFirstHeadCellCenteredText : styles.bandedTableHeadCellCenteredText;
    if (resourceName === 'coupons' && (field.key === 'actionValue' || field.key === 'autoApply' || field.key === 'exclusive')) return styles.tableHeadCellCouponSingleRow;
    if (resourceName === 'users') return styles.tableHeadCenterTitle;
    if (resourceName === 'options') {
      if (resource === 'customizations') return field.key !== 'outOfStock' ? styles.tableHeadCellSubresourceList : styles.subresourceListTableHeadCellSetWidth;
      return field.key !== 'outOfStock' ? styles.tableHeadWithBackgroundColor : styles.tableHeadWithSetWidth;
    }
    if (isTablet) return styles.tableHeadCellTablet;
    return styles.tableHeadCell;
  }

  onClickAddResource = () => {
    const {
      actions, match, history, resourceName, categories, onClickAddResourceOverride,
    } = this.props;
    const { resource, subResource, resourceId } = match.params;
    if (onClickAddResourceOverride && typeof onClickAddResourceOverride === 'function') {
      onClickAddResourceOverride();
      return;
    }

    // TODO: subResources may not need to call following action
    actions.clearErrors();
    const primaryResource = (resource === 'menu') ? resourceName : resource;
    if (resourceName === 'products') {
      history.push({
        pathname: `/${primaryResource}/create`,
        state: { categories },
      });
    } else if (subResource) {
      history.push(`/${primaryResource}/${resourceId}/${subResource}/create`);
    } else {
      history.push(`/${primaryResource}/create`);
    }
  }

  handleMenuOpen = (event, index) => {
    this.setState({ anchorEl: event.currentTarget });
    this.state.isMenuOpen[index] = true;
  }

  handleMenuClose = (index) => {
    this.setState({ anchorEl: null });
    this.state.isMenuOpen[index] = false;
  }

  getYesOnlyCouponDisplayValue = ({ fieldData }) => {
    fieldData = 'YES';
    return fieldData;
  }

  getMonthNameForBirthMonth = ({ fieldData, data }) => {
    fieldData = getMonthName(data);
    return fieldData;
  }

  makeFieldDataNull = ({ fieldData }) => {
    fieldData = 'N/A';
    return fieldData;
  }

  showCustomizationDisplayValue = ({ rowData, admin, field }) => {
    const customizations = rowData.customizations;
    if (!customizations || customizations.length === 0) return 'NO';
    if (!checkIsAuthorized(admin, 'customizations', null, 'view')) {
      return this.getFieldDataFromType(customizations, field);
    } else {
      let displayNames = [];
      let excessNames = [];
      const modifierValues = this.getDisplayAndExcessNames(customizations, displayNames, excessNames, true);
      const excessCount = excessNames.length;
      const length = excessCount > 0 ? displayNames.length : modifierValues.length;
      const { modifierIds, modifierNames } = this.getModifierIdAndNames(modifierValues, length);
      let modifierText = this.getDisplayValueInStringFormat(modifierNames, excessNames, modifierNames, excessCount);
      modifierText = this.turnModifierStringToLink(modifierText, modifierIds);
      return excessCount > 0 ? this.renderDropdownListWithExcessCount(modifierText, excessNames, excessCount) : modifierText;
    }
  }

  getModifierIdAndNames = (modifierValues, length) => {
    let modifierIds = [];
    let modifierNames = [];
    modifierValues.map((modifier, index) => {
      modifierIds.push(modifier.id);
      if (index !== length) modifierNames.push(modifier.name);
    })
    return { modifierIds, modifierNames };
  }

  turnModifierStringToLink = (modifierText, modifierIds) => {
    return (
      <Link
        to={{
          pathname: '/customizations',
          state: { fromOptions: true, modifierIds },
        }}
        style={styles.mainTableCellWithLinkContent}
      >
      {modifierText}
      </Link>
    );
  }

  getCustomizationOptionsDisplayValue = ({
    rowData,
    fieldData,
    admin,
    resource,
  }) => {
    const text = makeSubResourceNameList(rowData, 'options', 'name', false);
    const authorizedLinkText = <Link to={`/customizations/${rowData.id}/options`} style={styles.mainTableCellWithLinkContent}>{text}</Link>;
    fieldData = checkIsAuthorized(admin, resource, 'options', 'view')
      ? authorizedLinkText
      : text;
    return fieldData;
  }

  // Display YES/NO from boolean case of getFieldDataFromType when it's a single-select customization
  // true: default value (either included option or first option in list) selected
  // false: no values selected by default
  singleSelectDefaultOption = ({ rowData, fieldData, field }) => {
    const isSingleSelectCustomization = rowData.minOptions === 1 && rowData.maxOptions === 1;
    if (!isSingleSelectCustomization) {
      fieldData = 'N/A'; // N/A when it's a multi-select customization
    }
    return fieldData;
  }

  showOutOfStockDisplayValue = ({ rowData, fieldData, field }) => {
    const { isFromCreateEditModifier } = this.props;
    const { resource, subResource } = this.props.match.params;
    let outOfStockData = [];
    if (resource === 'menu' && subResource !== 'items') {
      outOfStockData = rowData.outOfStockLocations;
    }
    if (resource === 'customizations' && subResource === 'options') {
      outOfStockData = rowData['out-of-stock'] || rowData.outOfStockLocations;
    }
    if (isFromCreateEditModifier) {
      outOfStockData = rowData.outOfStockLocations;
    }
    if (resource === 'options') outOfStockData = rowData.outOfStockLocations;
    if (this.props.locations.length <= 1) {
      fieldData = this.getFieldDataFromType(outOfStockData, outOfStockBooleanVersion);
    }

    if (this.props.locations.length > 1) {
      fieldData = this.getFieldDataFromType(outOfStockData, field);
    }
    return fieldData;
  }

  getRestrictionsDisplayValue = ({ rowData, fieldData }) => {
    const restrictionType = rowData.type;
    if (['START_DATETIME', 'END_DATETIME'].includes(restrictionType)) {
      fieldData = new Date(fieldData).toString();
    }
    if (['LOCATIONS'].includes(restrictionType)) {
      const { locations } = this.props;
      let names = [];
      const locationIds = fieldData.split(',');
      if (Array.isArray(locations)) {
        names = locationIds.map((locationId, ind, arr) => {
          const locationInfo = locations.find(location => `${location.id}` === `${locationId}`);
          if (!locationInfo || !locationInfo.name) return '';
          return locationInfo.name;
        });
        const filteredEmptyValuesOut = names.filter(name => !!(name));
        return filteredEmptyValuesOut.join(', ');
      }
    }
    return fieldData;
  }

  renderPizzaPortions = ({ rowData, fieldData, field }) => {
    let optionsAndSubItems = [];
    const { options, subItems } = rowData;
    if (Array.isArray(subItems) && subItems.length > 0) {
      optionsAndSubItems = subItems.concat(options);
    } else {
      optionsAndSubItems = options;
    }
    fieldData = this.getFieldDataFromType(optionsAndSubItems, field);
    return fieldData;
  }

  formatResourceButtonName(button) {
    let str = button.btnTitle;
    if (str === 'zones') {
      return 'Delivery Zones';
    }
    if (str === 'catering-zones') return 'Catering Zones';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  handleKmlFile(resourceId, subResource, event) {
    const { apiToken, match } = this.props;
    const { resource } = match.params;

    event.stopPropagation();
    event.preventDefault();

    const confirmUpload = window.confirm(`Create and/or update ${subResource === 'catering-zones' ? 'Catering' : 'Delivery'} zones with the layer names and coordinates in your kml file ${event.target.files[0].name}?`);
    if (confirmUpload === true) {
      const file = event.target.files[0];
      const path = subResource === 'catering-zones' ? `${resource}/${resourceId}/${subResource}/kml` : `${resource}/${resourceId}/${subResource}`;
      sendKmlFile(apiToken, path, file);
    }
    event.target.value = null;
  }

  /**
   * Render search field and add resource button
   */
  renderToolbar = () => {
    const {
      resourceName,
      isSmallTable,
      viewOnly,
      handleSearch,
      handleClearSearch,
      exportFunction,
      importFunction,
      admin,
      match,
      isSeparateToolbar,
    } = this.props;

    const { resource } = match.params;
    const resourceTitle = changeResourceDisplayName(resourceName, resourceDisplayNameMap);
    let resourceToDisplay = depluralizeResourceName(resourceTitle);
    let capitalizedResource = capitalizeTheFirstLetterOfEachWord(resourceTitle);

    return (
      !(viewOnly || isSmallTable || isSeparateToolbar)
      && (
        <div style={resourceName !== 'options' ? styles.toolbarContainer : styles.optionsToolbarContainer}>
          {/* this is a hotfix: in the future, the Filter component may appear for multiple resources */}
          <div style={resourceName !== 'options' ? styles.toolbarLeftSideFlexStartContainer : styles.toolbarLeftSideOptionContainer}>
            {resourceName !== 'orders' && (
              <SearchComponent
                placeholder={`Search ${capitalizedResource}`}
                onHandleSearch={handleSearch}
                onHandleClearSearch={handleClearSearch}
                resourceName={resourceTitle}
              />
            )}
          </div>
          {bulkActionResourceNames.includes(resourceName) && this.renderBulkActionSelect()}
          {exportFunction && checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'view')
            && (
              <div style={styles.toolbarRightSideFlexEndContainer}>
                <Button variant="contained" onClick={() => exportFunction()} style={styles.exportButton}>
                  {`Export ${resourceToDisplay}s`}
                </Button>
              </div>
            )
          }
          {importFunction && checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'add')
            && (
              <div style={styles.toolbarRightSideFlexEndContainer}>
                <span>
                  <input
                    id="importInput"
                    name="importInput"
                    type="file"
                    accept=".xlsx"
                    style={{ display: 'none' }}
                    onChange={e => importFunction(e.target.files[0])}
                  />
                  <label htmlFor="importInput" style={styles.importButton}>
                    <span style={styles.importButtonSpan}>
                      {`Import ${resourceToDisplay}s`}
                    </span>
                  </label>
                </span>
              </div>
            )
          }
          {checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'add') && this.renderAddNewResourceButton(resourceToDisplay)}
        </div>
      )
    );
  }

  toggleBulkActionSelect = targetState => () => this.setState({ isBulkActionSelectOpen: targetState });

  onBulkActionDropdownChange = (event) => {
    const { pageSettings, resourceName } = this.props;
    const bulkActionIsCheckedMap = get(pageSettings, `${resourceName}.bulkActionIsCheckedMap`, {});
    const { value } = event.target;
    if (Object.keys(bulkActions).includes(value) && find(bulkActionIsCheckedMap, isChecked => !!isChecked)) {
      this.setState({
        isBulkActionConfirmDialogOpen: true,
        selectedBulkAction: value,
      });
    }
  }

  renderAddNewResourceButton = resourceToDisplay => (
    <div style={styles.toolbarRightSideFlexEndContainer}>
      <Button
        variant="contained"
        onClick={this.onClickAddResource}
        style={styles.addNewResButton}
      >
        {`${translation('Add New')} ${resourceToDisplay}`}
      </Button>
    </div>
  )


  renderTableBodyContent = () => {
    const { data, resourceName } = this.props;
    const menuResources = ['products', 'categories', 'customizations'];
    if (menuResources.includes(resourceName)) {
      switch (resourceName) {
        case 'products':
          data.sort((a, b) => {
            if (a.category.position > b.category.position) {
              return 1;
            }
            if (a.category.position < b.category.position) {
              return -1;
            }
            if (a.position > b.position) {
              return 1;
            }
            if (a.position < b.position) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            return 0;
          });
          break;
        case 'categories':
        case 'customizations':
          sortByPosition(data);
      }
    }
    if (resourceName === 'options') {
      sortByPosition(data);
    }
    return (
      data.map((rowData, index) => {
        if (rowData.id === 'viewMore') {
          return this.renderViewMoreTableBodyRow(rowData);
        } else {
          return this.renderTableBodyRow(rowData, index);
        }
      })
    );
  }

  onCloseDialog = () => {
    this.setState({ isDeleteConfirmDialogOpen: false, isBulkActionConfirmDialogOpen: false });
  }

  onClickConfirmDeleteButton = async () => {
    const {
      actions, apiToken, match, resourceName, onClickDeleteResource,
    } = this.props;
    const {
      resource, subResource, resourceId,
    } = match.params;
    const data = this.state.dataInDeleteConfirmDialog;
    const primaryResource = (resource === 'menu') ? resourceName : resource;
    actions.clearErrors();

    if (typeof onClickDeleteResource === 'function') {
      onClickDeleteResource(data.id);
      this.onCloseDialog();
      return;
    }
    if (subResource) {
      actions.deleteResource(apiToken, primaryResource, resourceId, subResource, data.id);
    } else if (primaryResource === 'locations') {
      data.isDeleted = true;
      actions.updateResource(apiToken, data, primaryResource, data.id);
    } else if ((primaryResource === 'categories' || primaryResource === 'menu') && data.timeLimits && data.timeLimits.length > 0) {
      await actions.deleteResource(apiToken, primaryResource, data.id, 'time-limits', data.timeLimits[0].id);
      actions.deleteResource(apiToken, primaryResource, data.id);
    } else {
      actions.deleteResource(apiToken, primaryResource, data.id);
    }
    this.onCloseDialog();
  }

  /**
   * @description
   * determine table height base on conditions
   */
  tableHeightCalculator = () => {
    const {
      viewOnly,
      isSmallTable,
      resourceName,
      admin,
      match,
      isSeparateToolbar,
    } = this.props;
    const { resource } = match.params;
    let height = '';

    const shouldShowAddResourceButtonForSmallTable = checkIsAuthorized(admin, resource, this.getRightSubResourceOrSmallTableParam(), 'add');
    if (!viewOnly && !isSmallTable) {
      height = '85%'; // for resource table that come with a toolbar, e.g users, locations
    } else if (viewOnly && !isSmallTable) {
      height = '100%'; // for resource table without toolbar, only for orders
    } else if (isSmallTable && shouldShowAddResourceButtonForSmallTable) {
      height = '60%'; // for three small resource tables in menu page, e.g categories, customizations, taxes
    } else if (isSmallTable && !shouldShowAddResourceButtonForSmallTable) {
      height = '80%';
    }
    if (isSeparateToolbar) {
      height = '100%';
    }
    return height;
  }

  tableRootStyles = () => {
    const { resourceName, bandedTable, isTablet } = this.props;
    const { hideToolbar } = this.props;
    if (resourceName === 'orderItems') return { ...viewStyles.tableRootContainer, height: 'auto' };
    if (bandedTable) return styles.bandedTableRootContainer;
    if (isTablet) return { ...styles.tableRootContainerTablet, height: this.tableHeightCalculator() };
    if (resourceName === 'options') {
      if (hideToolbar) return { ...styles.optionsOnModifierTableRoot, height: this.tableHeightCalculator() };
      return { ...styles.tableRootContainerOptions, height: this.tableHeightCalculator() };
    }
    return { ...styles.tableRootContainer, height: this.tableHeightCalculator() };
  }

  assignOutOfStockLocations = (locations, isSingleLocation, authorizedLocations, resourceName) => {
    if (resourceName === 'options') return { outOfStockLocations: isSingleLocation ? locations[0] : locations.filter(location => authorizedLocations.includes(location.id)), }
    return { outOfStockLocations: isSingleLocation ? [locations[0].id] : authorizedLocations }
  }

  assignInStockLocations = (locations, isSingleLocation, payload, selectedLocations, resourceName) => {
    if (resourceName === 'options') {
      const { outOfStockLocations } = payload;
      const outOfStockIfChangedViaBulkActionAlready = payload['out-of-stock'];
      const currentOutOfStockLocations = outOfStockIfChangedViaBulkActionAlready || outOfStockLocations;
      const newOutOfStockLocations = isSingleLocation || !Array.isArray(currentOutOfStockLocations)
        ? []
        : currentOutOfStockLocations.filter(location => !selectedLocations.includes(location.id));

      return { outOfStockLocations: newOutOfStockLocations };
    }
    return { outOfStockLocations: isSingleLocation ? [] : payload.outOfStockLocations.filter(item => !selectedLocations.includes(item)), }
  }

  onClickConfirmBulkAction = () => {
    const { selectedBulkAction, selectedBulkOutOfStockLocations } = this.state;
    const {
      pageSettings,
      resourceName,
      data,
      actions,
      apiToken,
      locations,
      admin,
      match,
    } = this.props;
    const { resource } = match.params;
    if (selectedBulkAction === '') {
      this.setState({ isBulkActionConfirmDialogOpen: false });
      return;
    }
    const isSingleLocation = locations && locations.length === 1;
    if (Object.keys(bulkActions).includes(selectedBulkAction) && bulkActionResourceNames.includes(resourceName)) {
      const bulkActionIsCheckedMap = get(pageSettings, [resourceName, 'bulkActionIsCheckedMap'], {});
      const payload = data.filter(product => bulkActionIsCheckedMap[product.id] === true)
        .map((p) => {
          let basePayload = { id: p.id };
          if (resourceName === 'products' || resourceName === 'options') {
            if (selectedBulkAction == 'outOfStock') {
              const newOutOfStockLocations = this.getBulkOutOfStockLocations(p, admin);
              Object.assign(basePayload, this.assignOutOfStockLocations(locations, isSingleLocation, newOutOfStockLocations, resourceName));
            } else if (selectedBulkAction == 'inStock') {
              Object.assign(basePayload, this.assignInStockLocations(locations, isSingleLocation, p, selectedBulkOutOfStockLocations, resourceName));
            }
          }
          return basePayload;
        });

      if (resourceName === 'options') {
        if (selectedBulkAction === 'outOfStock' || selectedBulkAction === 'inStock') {
          (resource === 'options') ? this.setBulkOutOfStockOptionsAsResource(payload) : this.setBulkOutOfStockOptionsAsSubResource(payload);
        } else if (selectedBulkAction === 'delete') {
          (resource === 'options') ? this.deleteBulkOptionsAsResource(payload) : this.deleteBulkOptionsAsSubResource(payload);
          this.onCloseDialog();
        }
      } else {
        actions.updateResource(apiToken, payload, resourceName, bulkActions[selectedBulkAction].uri).then((res) => {
          if (bulkActions[selectedBulkAction].uri === 'bulk-out-of-stock') {
            actions.getAllResources(apiToken, `products?start=0&count=${productPaginationCount}`);
          }
        });
      }
    }
  }

  setBulkOutOfStockOptionsAsSubResource = (payload) => {
    const { apiToken, actions, match } = this.props;
    const { resource, resourceId, subResource } = match.params;
    payload.forEach(async (option) => {
      await actions.updateResource(apiToken, option.outOfStockLocations, resource, resourceId, subResource, option.id, 'out-of-stock');
    });
  }

  setBulkOutOfStockOptionsAsResource = (payload) => {
    const { apiToken, actions } = this.props;
    payload.forEach(async (option) => {
      await actions.updateResource(apiToken, option.outOfStockLocations, 'options', option.id, 'out-of-stock');
    });
  }

  deleteBulkOptionsAsSubResource = (payload) => {
    const { apiToken, actions, match } = this.props;
    const { resource, resourceId, subResource } = match.params;
    payload.forEach(async (option) => {
      await actions.deleteResource(apiToken, resource, resourceId, subResource, option.id);
    });
  }

  deleteBulkOptionsAsResource = (payload) => {
    const { apiToken, actions } = this.props;
    payload.forEach(async (option) => {
      await actions.deleteResource(apiToken, 'options', option.id);
    });
  }

  bulkActionMessage = () => {
    const { selectedBulkAction } = this.state;
    const { resourceName, locations } = this.props;
    const targetResources = this.getTargetResourceNames('bulk');
    const targetResourceNames = Array.isArray(targetResources)
      ? targetResources.map(resource => <div key={resource.id} style={bulkActionStyles.truncatedBulkTargetResourceName}>{resource.name}</div>)
      : [];
    const targetResourcesContainerStyle = targetResourceNames.length < 6
      ? actionConfirmStyles.bulkTargetResources
      : actionConfirmStyles.bulkTargetResourcesWithVertScrollbar;
    const shouldShowSelectLocation = ['outOfStock', 'inStock'].includes(selectedBulkAction)
      && locations
      && locations.length > 1;

    return (
      <div style={bulkActionStyles.messageAndTargetResourcesContainer}>
        {
          shouldShowSelectLocation
          && (
            <Fragment>
              <Typography style={bulkActionStyles.bulkActionAreYouSureQuestion}>
                {bulkActions[selectedBulkAction].dialogSlectText}
              </Typography>
              {this.renderBulkOutOfStockLocationDropdown()}
            </Fragment>
          )
        }
        <Typography style={bulkActionStyles.bulkActionAreYouSureQuestion}>
          {bulkActions[selectedBulkAction].dialogConfirmText.replace(/#RESOURCE#/g, resourceName)}
        </Typography>
        <div style={targetResourcesContainerStyle}>
          {targetResourceNames}
        </div>
      </div>
    );
  }

  renderBulkOutOfStockLocationDropdown = () => {
    const { classes, locations, admin } = this.props;
    const { selectedBulkOutOfStockLocations } = this.state;
    const adminLocationId = getLocationIdOfAuthorizationOrAdmin('locations', admin);

    const authorizedLocations = locations.filter(loc => !adminLocationId || loc.id === Number(adminLocationId));
    return (
      <Select
        value={selectedBulkOutOfStockLocations}
        style={{ ...styles.bulkActionDropdown, width: '100%' }}
        input={<InputBase />}
        displayEmpty
        multiple
        onChange={e => this.setState({ selectedBulkOutOfStockLocations: e.target.value })}
      >
        <MenuItem value='placeholder' disabled>Please Select...</MenuItem>
        {
          authorizedLocations.map(location => (
            <MenuItem
              key={location.id}
              value={location.id}
            >
              {location.name}
            </MenuItem>
          ))
        }
      </Select>
    );
  }

  bulkActionConfirmCancelButtons = () => {
    const { selectedBulkAction, selectedBulkOutOfStockLocations } = this.state;
    const { resourceName, locations } = this.props;
    const disableAction = ['outOfStock', 'inStock'].includes(selectedBulkAction)
      && locations
      && locations.length > 1
      && selectedBulkOutOfStockLocations.length == 0;

    return (
      <div>
        <Button
          style={actionConfirmStyles.confirmButton}
          onClick={this.onClickConfirmBulkAction}
          disabled={disableAction}
        >
          {bulkActions[selectedBulkAction].dialogBtnText.replace(/#RESOURCE#/g, resourceName).toUpperCase()}
        </Button>
        <Typography
          style={actionConfirmStyles.cancelText}
          onClick={this.onCloseDialog}
        >
          Cancel
        </Typography>
      </div>
    );
  }

  getTargetResourceNames = (action) => {
    const { isDeleteConfirmDialogOpen, isBulkActionConfirmDialogOpen, dataInDeleteConfirmDialog } = this.state;
    if (action === 'delete' && isDeleteConfirmDialogOpen) return dataInDeleteConfirmDialog.name;

    if (action === 'bulk' && isBulkActionConfirmDialogOpen) {
      const { data, pageSettings, resourceName } = this.props;
      const bulkActionIsCheckedMap = get(pageSettings, [resourceName, 'bulkActionIsCheckedMap'], {});
      const targetResources = data.filter(resource => bulkActionIsCheckedMap[resource.id] === true);
      return targetResources;
    }

    return '';
  }

  getBulkOutOfStockLocations = (p, admin) => {
    const { selectedBulkOutOfStockLocations } = this.state;
    const outOfStockLocationsClone = p.outOfStockLocations.slice();

    const adminLocationId = getLocationIdOfAuthorizationOrAdmin('locations', admin);
    const withAdminLocation = outOfStockLocationsClone.includes(adminLocationId)
      ? outOfStockLocationsClone
      : [...outOfStockLocationsClone, adminLocationId];

    // Location admins can only add their locations. Normal admins instead do a "set" operation.
    const newOutOfStockLocations = adminLocationId
      ? withAdminLocation
      : selectedBulkOutOfStockLocations;
    return newOutOfStockLocations;
  }

  renderBulkActionSelect() {
    const { isBulkActionSelectOpen, selectedBulkAction } = this.state;
    const { classes, admin, resourceName } = this.props;
    const { resource } = this.props.match.params;
    const isLocationAdmin = checkIsLocationAdmin(admin);

    const authorizedActions = Object.entries(bulkActions).filter(([action, config]) => !isLocationAdmin || config.isUsableByLocationAdmins);

    return (
      <div style={styles.toolbarRightSideFlexEndContainer}>
        <FormControl>
          <Select
            open={isBulkActionSelectOpen}
            onOpen={this.toggleBulkActionSelect(true)}
            onClose={this.toggleBulkActionSelect(false)}
            value={selectedBulkAction}
            style={styles.bulkActionDropdown}
            classes={{
              root: classes.bulkActionInnerSelect,
              selectMenu: classes.bulkActionSelectMenu,
            }}
            input={<InputBase />}
            displayEmpty
            onChange={this.onBulkActionDropdownChange}
            IconComponent={DownChevronSelectToggle(this.toggleBulkActionSelect(!isBulkActionSelectOpen))}
          >
            <MenuItem value="">Bulk Actions...</MenuItem>
            {checkIsAuthorized(admin, resource, resourceName, 'edit')
              && (
                authorizedActions.map(([action, config]) => config.allowedPages.includes(resourceName) && (
                  <MenuItem value={action}>
                    {bulkActions[action].title}
                  </MenuItem>
                ))
              )}
          </Select>
        </FormControl>
      </div>
    );
  }

  render() {
    const { data, hideToolbar, resourceName } = this.props;
    const { isBulkActionConfirmDialogOpen, selectedBulkAction } = this.state;
    const resourceTitle = resourceName === 'products' ? 'items' : resourceName;
    return (
      // if the user clicks the first cell of row, will be redirected to view page for that resource instance
      !data
        ? <LoadingBar />
        : (
          <Fragment>
            {resourceName !== 'reports' && !hideToolbar && this.renderToolbar()}
            <div style={this.tableRootStyles()}>
              <Table style={resourceName === 'options' ? styles.table : null}>
                <TableHead style={styles.tableHead}>
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody style={styles.tableBody}>
                  {this.renderTableBodyContent()}
                </TableBody>
              </Table>
            </div>
            <DeleteConfirmDialog
              resourceName={resourceTitle}
              isDialogOpen={this.state.isDeleteConfirmDialogOpen}
              deleteDataName={this.getTargetResourceNames('delete')}
              onCloseDialog={this.onCloseDialog}
              onClickConfirmButton={this.onClickConfirmDeleteButton}
            />
            {bulkActionResourceNames.includes(resourceName) && selectedBulkAction && (
              <GeneralDialog
                type="bulkAction"
                open={isBulkActionConfirmDialogOpen}
                onClose={this.onCloseDialog}
                contentContainerStyle={bulkActionStyles.bulkActionDialogContainer}
                title={bulkActions[selectedBulkAction].dialogTitle.replace(/#RESOURCE#/g, resourceTitle).toUpperCase()}
                message={this.bulkActionMessage()}
                buttons={this.bulkActionConfirmCancelButtons()}
              />
            )}
          </Fragment>
        )
    );
  }
}

DisplayResources.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  buttonArray: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  exportFunction: PropTypes.func,
  fieldNames: PropTypes.arrayOf(PropTypes.object).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  hideToolbar: PropTypes.bool,
  importFunction: PropTypes.func,
  isSmallTable: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  onClickViewMore: PropTypes.func,
  onClickEditResource: PropTypes.func,
  onClickDeleteResource: PropTypes.func,
  resourceName: PropTypes.string.isRequired,
  searchedProducts: PropTypes.arrayOf(PropTypes.object),
  totalResource: PropTypes.number,
  viewMoreLoading: PropTypes.number,
  viewOnly: PropTypes.bool,
};

DisplayResources.defaultProps = {
  buttonArray: null,
  data: null,
  exportFunction: null,
  importFunction: null,
  isSmallTable: false,
  onClickDeleteResource: null,
  onClickEditResource: null,
  onClickViewMore: null,
  viewMoreLoading: 0,
  viewOnly: false,
  totalResource: 0,
};

const mapStateToProps = (state, props) => ({
  locations: getLocations(state),
  admin: getAdmin(state),
  pageSettings: getPageSettings(state),
});

const pipeline = flowRight([withStyles(displayResourceStyles), withRouter, connect(mapStateToProps)]);
export default pipeline(DisplayResources);
